
import { Box, Typography } from "@mui/material";
import governmentLogo from "../../../../assets/img/nepal-government-logo.png";
import { AppMisc } from "../../../../misc/appMisc";
import styles from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { getHealthClientAndPalikaInfoData } from "../../../../action/HealthClientInfo";
import { useEffect } from "react";

export default function HealthServiceCardHeader({ ...props }) {
  const healthClientInfo = useSelector(state => state.healthClientInfo);
  const dispatch = useDispatch();
  const classes = styles();

  useEffect(() => {
    !healthClientInfo && dispatch(getHealthClientAndPalikaInfoData());
  }, [healthClientInfo])

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <img src={governmentLogo} alt="Nepal Government HMIS" className={classes.logoWidth} />
        </Box>

        <Box textAlign="center" className={classes.mainHeader}>
          <Typography>नेपाल सरकार</Typography>
          <Typography>स्वास्थ्य तथा जनसंख्या मन्त्रालय</Typography>
          <Typography>आयुर्वेद तथा वैकल्पिक चिकित्सा विभाग</Typography>
          <Typography variant="h6">आयुर्वेद व्यवस्थापन सूचना प्रणाली</Typography>
          <Typography>{healthClientInfo?.palikaName && AppMisc.getMunicipalityName(healthClientInfo?.palikaName)}</Typography>
        </Box>

        <Box>
          {props.logoUrl && (
            <Box>
              <img className={classes.logoWidth} src={props.logoUrl} alt="Logo" />
            </Box>
          )}
        </Box>
      </Box>

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box flexGrow={1}>
          <Box mt={2}>
            <Typography>
              {`जिल्ला : ${AppMisc.getDistrictName(healthClientInfo?.district)}`}
            </Typography>
          </Box>
        </Box>

        <Box>
          <Box mt={2} display={"flex"} flexDirection={"column"} gridRowGap={5}>
            <Typography>
              {`स्वास्थ्य संस्था को नाम : ${healthClientInfo?.name}`}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}